import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import { styled } from "@mui/material/styles";
import { CircularProgress, IconButton } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import { ThreeDots } from "react-loader-spinner";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
  // Add the following style to increase the width
  "& .MuiDialog-paperWidthSm": {
    maxWidth: "100%", // Adjust the width as needed
  },
}));


interface DialogComponentProps {
  isLoading ?: boolean
  handleClose: () => void;
  dialogTitle: string;
  openDialog: boolean;
  dialogContent: React.ReactNode;
  handleSubmitBtn: () => void;
  disabledSubmitBtn?: boolean;
  submitBtnStyle?: React.CSSProperties | "";
  submitBtnName?: string;
  loading?: boolean;
  uploadBtn?: boolean;
  handleUploadBtn?: () => void;
  disabledUploadBtn?: boolean;
}

const DialogComponent: React.FC<DialogComponentProps> = ({
  handleClose,
  dialogTitle,
  openDialog,
  dialogContent,
  handleSubmitBtn,
  disabledSubmitBtn = false,
  submitBtnStyle,
  submitBtnName = "verify",
  loading = false,
  uploadBtn = false,
  handleUploadBtn,
  disabledUploadBtn,
  isLoading = false,
}) => {
  const submitStyle = {
    background: "#00A4E5",
    color: "#f2f2f2",
    borderRadius: "5px",
    ...submitBtnStyle,
  };

  const closeStyle = {
    background: "#E0E0E0",
    color: "#333",
    borderRadius: "5px",
  };
  return (
    <BootstrapDialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={openDialog}
      sx={{
        "& .MuiDialog-paper": {
          maxWidth: "350px",
          width: "350px",
        },
      }}
    >
      <DialogTitle
        sx={{
          m: 0,
          p: 2,
          height: "50px",
          display: "flex",
          alignItems: "center",
          fontFamily: `"Plus Jakarta Sans", sans-serif`,
        }}
      >
        {dialogTitle}
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={handleClose}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent dividers>{dialogContent}</DialogContent>
      <DialogActions className="d-flex justify-content-between">
        <Button autoFocus onClick={handleClose} style={closeStyle}>
          Cancel
        </Button>
        <div>
          <Button
            disabled={disabledSubmitBtn || isLoading}
            autoFocus
            onClick={handleSubmitBtn}
            style={submitStyle}
            sx={{
              "&.Mui-disabled": {
                backgroundColor: "rgb(108 213 255) !important",
              },
            }}
          >
          {isLoading ? (
  <span
    style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      // backgroundColor: "#00a4e5",
      color: "white",
      borderRadius: "50%",
      // height: "30px",
      // width: "30px",
    }}
  >
    <CircularProgress size={15} style={{ color: "white" }} />
  </span>
) : (
  submitBtnName
)}

          </Button>
          &ensp;
          {uploadBtn && (
            <Button
              disabled={disabledUploadBtn || isLoading}
              onClick={handleUploadBtn}
              style={submitStyle}
              sx={{
                "&.Mui-disabled": {
                  backgroundColor: "rgb(108 213 255) !important",
                },
              }}
            >
              Upload
            </Button>
          )}
        </div>
      </DialogActions>
      {loading && (
        <div
          className="p-4 d-flex  justify-content-center align-items-center h-100 w-100"
          style={{ position: "absolute", background: "#fff", opacity: 0.7 }}
        >
          <div
            className=""
            style={{ display: "flex", flexDirection: "column" }}
          >
            <ThreeDots
              height="45"
              width="45"
              radius="9"
              color="#00a4e5"
              ariaLabel="three-dots-loading"
              wrapperStyle={{}}
              wrapperClass=""
            />
            <span style={{ margin: "-9px" }}>Uploading</span>
          </div>
        </div>
      )}
    </BootstrapDialog>
  );
};

export default DialogComponent;
